if($('.type-post.in-blog').length){
    var wordsPerMinute = 200;
    var articleText = $('.text').text();
    var wordCount = articleText.trim().split(/\s+/).length;
    var readingTime = Math.ceil(wordCount / wordsPerMinute);
    function sklonujMinutu(min) {
        if (min === 1) return 'minuta';
        if (min >= 2 && min <= 4) return 'minuty';
        if (min >= 5 && min <= 20) return 'minut';
        var lastDigit = min % 10;
        var lastTwoDigits = min % 100;
        if (lastTwoDigits >= 11 && lastTwoDigits <= 14) return 'minut';
        if (lastDigit === 1) return 'minuta';
        if (lastDigit >= 2 && lastDigit <= 4) return 'minuty';
        return 'minut';
    }
    $('.news-item-detail > .text').before('<div class="readingTime">Doba čtení: ' + readingTime + ' ' + sklonujMinutu(readingTime) + '</div>');
}